export const UPLOAD_LOGO_SUCCESS_MESSAGE = 'Dealership logo uploaded successfully';
export const DELETE_LOGO_SUCCESS_MESSAGE = 'Dealership logo removed';
export const LOGO_MAX_SIZE_BYTES = 5 * 1024 * 1024;
export const LOGO_ACCEPTED_TYPES = ['image/png', 'image/jpeg', 'image/svg+xml'];
export const LOGO_ACCEPT_ATTRIBUTE = '.png,.jpg,.jpeg,.svg';
export const LOGO_OP_UPLOAD = 'upload';
export const LOGO_OP_DELETE = 'delete';
